import { useEffect, useState } from "react";
import Table from "../../../../components/Table";

function ReceiptsTable({
  objects,
  onSort,
  schema,
  selected,
  onCollapse,
  ...props
}) {
  const [receipts, setReceipts] = useState([]);
  useEffect(() => {
    setReceipts(objects);
  }, [objects]);

  return (
    <>
      <div className="d-flex flex-column">
        <Table
          fields={schema.fields}
          //   onClick={this.clickData.bind(this)}
          onCollapse={onCollapse}
          collapsable
          objects={receipts}
          excludeFields={Object.keys(schema.fields).reduce(
            (acc, key) => {
              const options = schema.fields[key];
              if (options.read === false || options._read === false) {
                acc.push(key);
              }
              switch (options._type || options.type) {
                case "Relation":
                case "Array":
                case "Object":
                case "File":
                  acc.push(key);
                  break;
                default:
              }
              return acc;
            },
            ["acl", "id", "created", "updated"],
          )}
          selected={selected}
          //   onSelect={this.onSelect.bind(this)}
          //   onSelectAll={this.onSelectAll.bind(this)}
          //   progress={progress}
          //   onClickItem={this.onClickItem.bind(this)}
          onSort={onSort}
          className="mt-1"
          {...props}
        />
      </div>
    </>
  );
}

export default ReceiptsTable;
